import { Dialog, DialogActions, DialogContent, type DialogProps, DialogTitle } from '@mui/material';
import { type ForwardedRef, type ReactNode, forwardRef } from 'react';

export interface ConfirmationDialogProps extends Omit<
  DialogProps,
  'title' | 'content' | 'className' | 'onClose'
> {
  open: boolean;
  onClose: DialogProps['onClose'];
  /**
   * Title must be a string or a span/non-blocking element.
   */
  title: ReactNode;
  children: ReactNode;
  actions: ReactNode;
}

export const ConfirmationDialog = forwardRef(
  (props: ConfirmationDialogProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { title, children, actions, onClose, ...dialogProps } = props;
    return (
      <Dialog maxWidth="xs" fullWidth onClose={onClose} {...dialogProps} ref={ref}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers={false}>{children}</DialogContent>
        <DialogActions
          sx={{
            flexDirection: 'row',
            gap: 0.5,
            '& >*': {
              flex: 1,
            },
          }}
        >
          {actions}
        </DialogActions>
      </Dialog>
    );
  }
);

ConfirmationDialog.displayName = 'ConfirmationDialog';
